import React from "react";
import "./Footer.css";
import { axiosCandidateInterest } from "../../Services/MessagesService";
import Button from "../Button/Button";
import { CandidateCampaignResponse } from "../../Classes/CandidateCampaignResponse";
import { ResponseType } from "../../Classes/Enums/ResponseType";
import Cookies from "js-cookie";

const Footer = (campaignResponse: CandidateCampaignResponse) => {
  const interest = async (interest: ResponseType) => {
    if (interest == ResponseType.Interested) {
      window.location.href =
        window.location.href.slice(0, window.location.href.indexOf("/", 10)) +
        "/thankyoucandidate";
    } else {
      window.location.href =
        window.location.href.slice(0, window.location.href.indexOf("/", 10)) +
        "/notinterested";
    }
    const updatedCampaignResponse = {
      ...campaignResponse,
      ResponseType: interest,
    };

    const result = await axiosCandidateInterest(updatedCampaignResponse);
    if (result && result.status == 200) {
      Cookies.set(
        updatedCampaignResponse.CandidateId || "",
        updatedCampaignResponse.CampaignId || "",
        { expires: 7 }
      );
    } else {
      console.log("Error with sending interest.");
    }
  };

  return (
    <div className="container footer-container">
      <div className="row footer-row">
        <div className="col interested-col">
          <Button
            path="InterestedArrowText.png"
            width="100%"
            height="100%"
            onClick={async () => interest(ResponseType.Interested)}
          />
        </div>
        <div className="col uninterested-col">
          <Button
            path="NotInterestedArrowText.png"
            width="100%"
            height="100%"
            onClick={async () => interest(ResponseType.NotInterested)}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
